import { Link, useRouter } from "easy-page-router/react";
import { useLang } from "./services/lang";
import { useEffect, useState } from "react";
import LaunchButton from "./components/LaunchButton";
import PopUp from "./components/PopUp";
import MessengerRedirect from "./components/MessengerRedirect";

export function Header({ title, link, children }: { title?: string, link?: string, children?: React.ReactNode }) {
    const { dict } = useLang();

    return <header>
        <div className="path">
            <Link href={`/${dict.url}`} className="titimeme"><span>ti</span><b>time</b><span>me</span></Link>
            {title && <> / <Link href={link || `/${dict.url}`}>{title}</Link></>}
        </div>
        <div className="nav">
            {children}
        </div>
    </header>;
}

export function Footer() {
    const { path } = useRouter();
    const { dict } = useLang();

    return <footer>
        <MessengerRedirect />
        {path[0] !== dict.url ? <div className="footer-launch">
            <PopUp />
            <LaunchButton />
        </div> : <div />}
        <div className="footer-creator">
            {dict.created} <a target="_blank" href="https://paulu.cz">Filip</a>
            <DonateButton />
        </div>
    </footer>;
}

function DonateButton() {
    const { dict } = useLang();

    const [index, setIndex] = useState(0);

    useEffect(() => {
        // set random after render to make deal with react hydrate
        setIndex(Math.floor(Math.random() * dict.donateButton.length));

        function changeIndex() {
            setIndex(i => {
                i++;
                if (i >= dict.donateButton.length) i = 0;
                return i;
            });
        }
        const interval = setInterval(changeIndex, 7000);
        return () => clearInterval(interval);
    }, []);

    return <Link className="donate-button" href={`/${dict.urlDonate}`}>
        {dict.donateButton.map((button, i) => <span key={button} className={i === index ? "active" : ""}>
            {button}
        </span>)}
    </Link>;
}